import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/scenario-list',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadChildren: () => import('./pages/dashboard/dashboard.routes').then(m => m.routes),
  },
  {
    path: 'scenario-list',
    canActivate: [authGuard],
    loadChildren: () => import('./pages/scenario-list/scenario-list.routes').then(m => m.routes),
  },
  {
    path: 'transport',
    canActivate: [authGuard],
    loadChildren: () => import('./pages/transport/transport.routes').then(m => m.routes),
  },
  {
    path: 'storage',
    canActivate: [authGuard],
    loadChildren: () => import('./pages/storage/storage.routes').then(m => m.routes),
  },
  {
    path: 'settings',
    canActivate: [authGuard],
    loadChildren: () => import('./pages/settings/settings.routes').then(m => m.routes),
  },
];
